import DS from 'ember-data';
import { decamelize } from '@ember/string';
export default DS.JSONSerializer.extend(DS.EmbeddedRecordsMixin, {
  serialize(snapshot, options = {}) {
    options.includeId = true;
    return this._super(snapshot, options);
  },
  attrs: {
    tooltips: {
      embedded: 'always'
    }
  },
  keyForAttribute(attr) {
    return decamelize(attr);
  },
  keyForRelationship(attr) {
    return decamelize(attr);
  }
});